import { FC, useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import R from 'src/routes';
import {
  CreatorDashboardContainerProps,
  CreatorDashboardProps,
} from './CreatorDashboard.types';
import { CreatorDashboard } from './CreatorDashboard.component';

const CreatorDashboardContainer: FC<CreatorDashboardContainerProps> = (
  props,
) => {
  const history = useHistory();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const handle = setTimeout(() => setCopied(false), 2000);
      return () => clearTimeout(handle);
    }
  }, [copied]);

  const handleCopy = useCallback<CreatorDashboardProps['onCopy']>((event) => {
    event.preventDefault();

    const input = event.currentTarget.url;

    // Select the text field
    input.select();
    input.setSelectionRange(0, 99999); /* For mobile devices */

    // Copy the text inside the text field
    navigator.clipboard.writeText(input.value);

    // Set state as copied
    setCopied(true);
  }, []);

  const handleBack = useCallback<CreatorDashboardProps['onBack']>(() => {
    history.push(R.HOME);
  }, [history]);

  return (
    <CreatorDashboard
      copied={copied}
      onCopy={handleCopy}
      onBack={handleBack}
      {...props}
    />
  );
};

export { CreatorDashboardContainer as CreatorDashboard };
